import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { UtilsService } from '../shared/services/utils/utils.service';
import { UserActivitiesService } from '../shared/services/user-activities/user-activities.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
    private _utilsService: UtilsService,
    private userActivitiesService: UserActivitiesService
  ) { }

  /**
   * Intercepts HTTP requests and modifies them before sending.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.addHiddenParams(request)).pipe(
      switchMap((modifiedRequest) => next.handle(modifiedRequest).pipe(
        map((response: HttpEvent<any>) => {
          if (response && response['body'] && response['body']['data'] && response['body']['data']['code'] && (response['body']['data']['code'] == 4053 || response['body']['data']['code'] == 402)) {
            // console.log("Logout.........")
            this.userActivitiesService.userInactive.next(true);
          }
          if (response && response['data'] && response['data']['code'] && (response['data']['code'] == 4053 || response['data']['code'] == 402)) {
            // console.log("Logout.........?")
            this.userActivitiesService.userInactive.next(true);
          }
          return response;
        })
      )),
      catchError((error: HttpErrorResponse) => this.handleError(error)) // Centralized error handling
    );
  }

  /**
   * Modifies HTTP request by adding necessary headers and encrypting sensitive data.
   */
  private async addHiddenParams(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    let headers = new HttpHeaders();
    const time = Date.now().toString()
    headers.set('Content-Type', 'application/json');
    headers.set('x-timestamp', time)
    headers.set('Cache-Control', 'no-store,no-cache')
    headers.set('Pragma', 'no-cache')
    // headers.set('X-XSS-Protection','1; mode=block');
    // headers.set('X-Content-Type-Options', 'nosniff');
    // headers.set('Strict-Transport-Security','max-age=63072000; includeSubDomains; preload');
    // headers.set('X-Frame-Options', 'SAMEORIGIN');
    // headers.set('Content-Security-Policy',policy);

    if (request.url.includes('validate')) {
      // Encrypt request body for validation API calls
      const encryptedBody = await this._utilsService.encryptDataPGP(request.body);
      return request.clone({
        body: { e: encryptedBody, encryption_version: 'v1' },
        headers,
        withCredentials: true
      });
    } else if (request.body?.is_external_api) {
      return request.clone({
        headers,
        withCredentials: false // Handle external API call like - Tokenization
      });
    } else if ('method' in request && (request['method'] == 'POST' || request['method'] == 'PUT') && request.url.includes('rateuss')) {
      // console.log("Encrypted for ", request['method'] , ' ', request['url']);
      const encryptedBody = await this._utilsService.encryptDataPGP(request.body);
      return request.clone({
        body: { e: encryptedBody, encryption_version: 'v1' },
        headers,
        withCredentials: true
      });
    } else {
      return request.clone({
        headers,
        withCredentials: true
      });
    }
  }

  /**
   * Centralized error handling for API responses.
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Error in API:', error);

    if (error.error?.code === 401 || error.error?.code === 402 || error.error?.text === '402 Not Authorized') {
      this.userActivitiesService.userInactive.next(true);
    }

    return throwError(() => error);
  }
}
